import { chunk } from './chunk';

export const formatNorwegianAccountNumber = (number: string) => {
    return chunk(number, [4, 2, 5]);
};
export const unformatNorwegianAccountNumber = (number: string) => {
    return number.replace(/\s/g, '');
};

export const formatAccountNumber = (country: string, number: string) => {
    if (country === 'NO') {
        return formatNorwegianAccountNumber(number.replace(/\s/g, ''));
    }
    return number;
};

export const unformatAccountNumber = (country: string, number: string) => {
    if (country === 'NO') {
        return unformatNorwegianAccountNumber(number);
    }
    return number;
};
